import React from "react";

/**
 * @component RocketSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <RocketSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RocketSmallIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      data-testid="RocketSmallIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M11.4 13.35H3v-3l1.828-2.284a12.928 12.928 0 01-.028-.838C4.8 5.079 6.6 2.52 9 .75c2.4 1.77 4.2 4.33 4.2 6.478 0 .265-.01.547-.027.838L15 10.35v3h-3.6zm.89-1.2h1.51v-1.38l-.825-1.03c-.151.878-.38 1.734-.686 2.41zm-6.58 0c-.305-.676-.534-1.532-.685-2.41L4.2 10.77v1.38h1.51zm5.978 2.4L9 17.55l-2.688-3h5.376zM9 15.75l1.152-1.2H7.848L9 15.75zM6 7.228c0 1.958.52 4.184 1.065 4.922h3.87C11.48 11.412 12 9.186 12 7.228c0-1.448-1.178-3.383-3-4.945C7.178 3.845 6 5.78 6 7.228zm3 .722a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4z" />
    </svg>
  )
);
RocketSmallIcon.displayName = "RocketSmallIcon";
export default RocketSmallIcon;
